export default class ThimSlider extends elementorModules.frontend.handlers.SwiperBase {
	getDefaultSettings() {
		return {
			selectors: {
				carousel: '.thim-ekits-sliders',
				gallery: '.thim-ekits-gallery-thumbs',
				slideContent: '.swiper-slide',
				sliderMobile: '.thim-ekits-mobile-sliders'
			},
		};
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );

		const elements = {
			$swiperContainer: this.$element.find( selectors.carousel ),
			$swiperGallery: this.$element.find( selectors.gallery ),
			$swiperSliderMobile: this.$element.find( selectors.sliderMobile ),
		};

		elements.$slides = elements.$swiperContainer.find( selectors.slideContent );

		// add Slider for mobile with layout default
		// elements.$swiperSliderMobile = elements.$swiperSliderMobile.find(' > div');

		return elements;
	}

	getSwiperOptions() {
		const elementSettings = this.getElementSettings(),
			slidesToShow = +elementSettings.slidesPerView || 3,
			isSingleSlide = 1 === slidesToShow,
			elementorBreakpoints = elementorFrontend.config.breakpoints,
			defaultSlidesToShowMap = {
				small_mobile: 1,
				mobile: 1,
				tablet: isSingleSlide ? 1 : 2,
			};
		let swiperOptions = {
			slidesPerView: slidesToShow,
			loop: 'yes' === elementSettings.slider_loop,
			speed: elementSettings.slider_speed,
			//handleElementorBreakpoints: true,
			freeMode: false,
			watchSlidesProgress: true,
		};

		if (this.elements.$swiperContainer.hasClass( 'thim-ekits-testimonial__avatars' )) {
			swiperOptions = {
				slidesPerView: 'auto',
				loop: true,
				loopedSlides: +elementSettings.slidesPerView || 3,
				speed: elementSettings.slider_speed,
				handleElementorBreakpoints: true,
				centeredSlides: true,
				slideToClickedSlide: true,
				watchSlidesProgress: true,
			};

			if ('yes' === elementSettings.slider_autoplay) {
				swiperOptions.autoplay = {
					delay: elementSettings.autoplay_speed,
					disableOnInteraction: 'yes' === elementSettings.pause_on_interaction,
				};
			}
		} else {
			swiperOptions.breakpoints = {};
			let lastBreakpointSlidesToShowValue = slidesToShow,
				screenName;

			Object.keys( elementorBreakpoints ).reverse().forEach( ( breakpointName ) => {
				if (elementorBreakpoints[breakpointName] == '1660') {
					screenName = 'widescreen';
				} else if (elementorBreakpoints[breakpointName] == '768') {
					screenName = 'tablet';
				} else if (elementorBreakpoints[breakpointName] == '480') {
					screenName = 'mobile';
				} else if (elementorBreakpoints[breakpointName] == '0') {
					screenName = 'mobile';
				}

				const defaultSlidesToShow = defaultSlidesToShowMap[screenName] ? defaultSlidesToShowMap[screenName] : lastBreakpointSlidesToShowValue;
				swiperOptions.breakpoints[elementorBreakpoints[breakpointName]] = {
					slidesPerView: +elementSettings['slidesPerView_' + screenName] || defaultSlidesToShow,
					slidesPerGroup: +elementSettings['slidesPerGroup_' + screenName] || 1,
					spaceBetween: +elementSettings['spaceBetween_' + screenName] || elementSettings.spaceBetween,
				};

				lastBreakpointSlidesToShowValue = +elementSettings['slidesPerView_' + screenName] || defaultSlidesToShow;
			} );
		}

		if ('yes' === elementSettings.centered_slides) {
			swiperOptions.centeredSlides = true;
		}

		if ('yes' === elementSettings.slider_autoplay) {
			swiperOptions.autoplay = {
				delay: elementSettings.autoplay_speed,
				disableOnInteraction: 'yes' === elementSettings.pause_on_interaction,
			};
		}

		if (isSingleSlide) {
			swiperOptions.effect = elementSettings.effect;

			if ('fade' === elementSettings.effect) {
				swiperOptions.fadeEffect = { crossFade: true };
			}
		} else {
			swiperOptions.slidesPerGroup = +elementSettings.slidesPerGroup || 1;
		}

		if (elementSettings.direction) {
			swiperOptions.handleElementorBreakpoints = true;
		}

		if (elementSettings.spaceBetween) {
			swiperOptions.spaceBetween = elementSettings.spaceBetween;
		}

		if ('yes' === elementSettings.slider_show_arrow) {
			swiperOptions.navigation = {
				prevEl: `.elementor-element-${ this.getID() } .thim-slider-nav-prev`,
				nextEl: `.elementor-element-${ this.getID() } .thim-slider-nav-next`,
			};
		}

		switch (elementSettings.slider_show_pagination) {
		case 'number':
			swiperOptions.pagination = {
				el: `.elementor-element-${ this.getID() } .thim-slider-pagination`,
				clickable: true,
				renderBullet( index, className ) {
					return '<span class="' + className + '">' + ( index + 1 ) + '</span>';
				},
			};
			break;
		case 'scrollbar':
			swiperOptions.scrollbar = {
				el: `.elementor-element-${ this.getID() } .thim-slider-pagination`,
				hide: true,
			};
			break;
		case 'bullets':
		case 'progressbar':
		case 'fraction':
			swiperOptions.pagination = {
				el: `.elementor-element-${ this.getID() } .thim-slider-pagination`,
				type: elementSettings.slider_show_pagination,
				clickable: true,
			};
			break;
		case 'yes':
			swiperOptions.pagination = {
				el: `.elementor-element-${ this.getID() } .thim-slider-pagination`,
				type: 'bullets',
				clickable: true,
			};
			break;
		}

		return swiperOptions;
	}

	getSwiperOptionsGallery( carousel ) {
		const elementSettings = this.getElementSettings();
		let swiper_opt_gallery = {
			loop: true,
			slidesPerView: 1,
			speed: elementSettings.slider_speed,
		};
		swiper_opt_gallery.spaceBetween = 30;
		if (this.elements.$swiperContainer.hasClass( 'thim-ekits-testimonial__avatars' )) {
			swiper_opt_gallery = {
				loop: true,
				// slidesPerView: 1,
				loopedSlides: +elementSettings.slidesPerView || 3,
				speed: elementSettings.slider_speed,
				autoplay: false,
			};
		} else {
			swiper_opt_gallery.thumbs = {
				swiper: carousel,
			};
			if ('yes' === elementSettings.slider_show_arrow) {
				swiper_opt_gallery.navigation = {
					prevEl: `.elementor-element-${ this.getID() } .thim-slider-nav-prev`,
					nextEl: `.elementor-element-${ this.getID() } .thim-slider-nav-next`,
				};
			}
		}
		if ('yes' === elementSettings.slider_autoplay && ! this.elements.$swiperContainer.hasClass( 'thim-ekits-testimonial__avatars' )) {
			swiper_opt_gallery.autoplay = {
				delay: elementSettings.autoplay_speed,
				disableOnInteraction: 'yes' === elementSettings.pause_on_interaction,
			};
		}

		return swiper_opt_gallery;
	}
	async onInit( ...args ) {
		super.onInit( ...args );

		const elementSettings = this.getElementSettings();

		if (this.elements.$swiperSliderMobile.length) {
			this.originalHTML = this.elements.$swiperSliderMobile.html();
			if (window.innerWidth <= 768) {
				this.initMobileSwiper();
			}
			this.eventsMobile();
		}

		if (! this.elements.$swiperContainer.length || 2 > this.elements.$slides.length) {
			return;
		}

		// const Swiper = elementorFrontend.utils.swiper;
		const Swiper = elementorFrontend.utils.swiper;

		this.swiper = await new Swiper( this.elements.$swiperContainer, this.getSwiperOptions() );

		// Expose the swiper instance in the frontend
		this.elements.$swiperContainer.data( 'swiper', this.swiper );

		// gallery slider
		if (this.elements.$swiperGallery.length) {
			this.swiper_gallery = await new Swiper( this.elements.$swiperGallery, this.getSwiperOptionsGallery( this.swiper ) );
			this.elements.$swiperGallery.data( 'swiper', this.swiper_gallery );

			if (this.elements.$swiperContainer.hasClass( 'thim-ekits-testimonial__avatars' )) {
				this.swiper_gallery.controller.control = this.swiper;
				this.swiper.controller.control = this.swiper_gallery;

				if ('yes' === elementSettings.pause_on_hover) {
					this.$element.on( 'mouseenter', () => {
						this.swiper.autoplay.stop();
					} ).on( 'mouseleave', () => {
						this.swiper.autoplay.start();
					} );
				}
			}
		}

		if ('yes' === elementSettings.pause_on_hover) {
			this.togglePauseOnHover( true );
		}
	}
	updateSwiperOption( propertyName ) {
		const elementSettings = this.getElementSettings(),
			newSettingValue = elementSettings[propertyName],
			params = this.swiper.params;

		// Handle special cases where the value to update is not the value that the Swiper library accepts.
		switch (propertyName) {
		case 'autoplay_speed':
			params.autoplay.delay = newSettingValue;
			break;
		case 'speed':
			params.speed = newSettingValue;

			break;
		}

		this.swiper.update();
	}

	getChangeableProperties() {
		return {
			pause_on_hover: 'pauseOnHover',
			autoplay_speed: 'delay',
			speed: 'speed',
		};
	}

	onElementChange( propertyName ) {
		const changeableProperties = this.getChangeableProperties();

		if (changeableProperties[propertyName]) {
			// 'pause_on_hover' is implemented by the handler with event listeners, not the Swiper library.
			if ('pause_on_hover' === propertyName) {
				const newSettingValue = this.getElementSettings( 'pause_on_hover' );

				this.togglePauseOnHover( 'yes' === newSettingValue );
			} else {
				this.updateSwiperOption( propertyName );
			}
		}
	}

	// onEditSettingsChange(propertyName) {
	// 	if ('activeItemIndex' === propertyName) {
	// 		this.swiper.slideToLoop(this.getEditSettings('activeItemIndex') - 1);
	// 	}
	// }
	mobileOptions() {
		const elementSettings = this.getElementSettings();
		let swiperOptions = {
			slidesPerView: 1,
			simulateTouch: true,
 			loop         : true,
 			speed        : 500,
			spaceBetween: 20,
 			breakpoints: {
 				481: {
					slidesPerView: 2,
 				},
			},
		};

		// if ( elementSettings.mobile_spaceBetween ) {
		// 	swiperOptions.spaceBetween = elementSettings.mobile_spaceBetween;
		// } else {
		// 	swiperOptions.spaceBetween= 20;
		// }

		swiperOptions.pagination = {
			el       : `.elementor-element-${this.getID()} .mobile-slider-pagination`,
			type     : 'bullets',
			clickable: true,
		};

		if ('yes' === elementSettings.slider_mobile_autoplay) {
			swiperOptions.autoplay = {
				delay: elementSettings.autoplay_speed_mobile,
				disableOnInteraction: true,
			};
		}

 		return swiperOptions;
	}

	initMobileSwiper() {
		const Swiper = elementorFrontend.utils.swiper;
		if (!this.swiper) {
			this.elements.$swiperSliderMobile.addClass('swiper').html(`
				<div class="swiper-wrapper">
					${this.elements.$swiperSliderMobile.children()
				.map((_, el) => `<div class="swiper-slide">${el.outerHTML}</div>`)
				.get()
				.join('')}
				</div>
				<div class="mobile-slider-pagination"></div>
			`);
			// Khởi tạo Swiper
			this.swiper = new Swiper(this.elements.$swiperSliderMobile[0], this.mobileOptions());
		}
	}

	onMobileResize() {
		if (window.innerWidth <= 767) {
			if (!this.swiper) {
				this.initMobileSwiper();
			}
		} else if (this.swiper) {
			// destroy slider
			super.onDestroy(true, true);
			this.swiper = null;
			this.elements.$swiperSliderMobile.removeClass('swiper swiper-initialized swiper-horizontal swiper-pointer-events').html(this.originalHTML);
		}
	}

	eventsMobile() {
		window.addEventListener('resize', this.onMobileResize.bind(this));
	}
}
